import React from 'react';
import aboutImage from '../../../assets/images/home/about_image.jpg';

const AboutSection = () => {
    return (
        <section className="py-20 bg-white relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                    {/* Left Side - Image */}
                    <div className="relative">
                        <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 to-purple-500/20 rounded-2xl transform rotate-6"></div>
                        <img
                            src={aboutImage}
                            alt="Education Innovation"
                            className="relative rounded-2xl shadow-xl w-full h-auto"
                        />
                    </div>

                    {/* Right Side - Content */}
                    <div className="space-y-6">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                            Transforming Education Through Innovation
                        </h2>
                        <h3 className="text-2xl font-semibold text-primary">
                            Empowering Learners with AI-Powered Solutions
                        </h3>
                        <div className="space-y-4 text-gray-600">
                            <p>
                                At NexGen Learning, we believe in the power of personalized education. Our innovative AI-driven platform tailors learning experiences to meet the unique needs of each individual, fostering engagement and growth.
                                Whether in a classroom or a corporate setting, our virtual teachers provide adaptive, interactive, and collaborative learning opportunities, ensuring that every learner can thrive in their educational journey.
                                Join us in revolutionizing the way we learn!
                            </p>
                        </div>
                        <div className="pt-4">
                            <button className="btn-primary text-white px-8 py-3 rounded-lg hover:bg-indigo-600 transition-colors duration-200">
                                Learn More
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection; 